var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#45AAB8",
    points: "58,50.586 46.586,61.998 17.414,61.998 6,50.586 6,15.998 58,15.998  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M6,59.998c0,1.105,0.896,2,2,2h6.586L6,53.412V59.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9EBB2",
    d: "M49.414,61.998H56c1.104,0,2-0.895,2-2v-6.586L49.414,61.998z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M62,11.998c0,1.105-0.896,2-2,2H4c-1.104,0-2-0.895-2-2v-8c0-1.104,0.896-2,2-2h56c1.104,0,2,0.896,2,2 V11.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M60-0.002H4c-2.211,0-4,1.789-4,4v8c0,2.211,1.789,4,4,4v44c0,2.211,1.789,4,4,4h48c2.211,0,4-1.789,4-4 v-44c2.211,0,4-1.789,4-4v-8C64,1.787,62.211-0.002,60-0.002z M58,50.586L46.586,61.998H17.414L6,50.586V15.998h52V50.586z  M6,59.998v-6.586l8.586,8.586H8C6.896,61.998,6,61.104,6,59.998z M56,61.998h-6.586L58,53.412v6.586 C58,61.104,57.104,61.998,56,61.998z M62,11.998c0,1.105-0.896,2-2,2H4c-1.104,0-2-0.895-2-2v-8c0-1.104,0.896-2,2-2h56 c1.104,0,2,0.896,2,2V11.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M21,31.998h22c1.657,0,3-1.344,3-3s-1.343-3-3-3H21c-1.657,0-3,1.344-3,3S19.343,31.998,21,31.998z  M21,27.998h22c0.553,0,1,0.447,1,1s-0.447,1-1,1H21c-0.553,0-1-0.447-1-1S20.447,27.998,21,27.998z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#506C7F",
    d: "M21,27.998h22c0.553,0,1,0.447,1,1s-0.447,1-1,1H21c-0.553,0-1-0.447-1-1S20.447,27.998,21,27.998z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxSvgrepoCom);
export default __webpack_public_path__ + "static/media/box-svgrepo-com.92a88d4f273f6afa8013eaf4242a8843.svg";
export { ForwardRef as ReactComponent };